module.exports = "<p>\n  layout2 works!\n</p>\n"